import { gatewayRequestAxios } from './interceptor'
import { GATEWAY_API_USERS_URL } from '../constants/urls'

export const createUser = (payload) => gatewayRequestAxios.post(GATEWAY_API_USERS_URL, payload)

export const updateUser = (payload, userId) => gatewayRequestAxios.patch(`${GATEWAY_API_USERS_URL}/${userId}`, payload)

export const deleteUser = (userId) => gatewayRequestAxios.delete(`${GATEWAY_API_USERS_URL}/${userId}`)

export const fetchUser = (userId) => gatewayRequestAxios.get(`${GATEWAY_API_USERS_URL}/${userId}?extended_properties=true&mfa=true`)

export const unlockUser = (payload, userId) => gatewayRequestAxios.post(`${GATEWAY_API_USERS_URL}/${userId}/lifecycle/unlock`, payload)

export const resetPassword = (payload, userId) => gatewayRequestAxios.post(`${GATEWAY_API_USERS_URL}/${userId}/lifecycle/reset_password`, payload)

export const forgotPassword = (payload, userId) => gatewayRequestAxios.post(`${GATEWAY_API_USERS_URL}/${userId}/lifecycle/forgot_password`, payload)

export const sendActivationEmail = (payload, userId) => gatewayRequestAxios.post(`${GATEWAY_API_USERS_URL}/${userId}/lifecycle/activate`, payload)

export const resendActivationEmail = (payload, userId) => gatewayRequestAxios.post(`${GATEWAY_API_USERS_URL}/${userId}/lifecycle/reactivate`, payload)

export const fetchUsers = (payload) => gatewayRequestAxios.get(GATEWAY_API_USERS_URL, {
    params: { q: payload }
});

export const fetchAuthenticatorEnrollments = (userId) => gatewayRequestAxios.get(`${GATEWAY_API_USERS_URL}/${userId}/authenticatorEnrollments`)

export const sendReActivationEmail = (payload, userId) => gatewayRequestAxios.post(`${GATEWAY_API_USERS_URL}/${userId}/lifecycle/reactivate`, payload)

export const bulkUploadUsers = (payload) => gatewayRequestAxios.post(`${GATEWAY_API_USERS_URL}/bulk-upload`, payload);

export const resetMultiFactor = (payload, userId) => gatewayRequestAxios.post(`${GATEWAY_API_USERS_URL}/${userId}/lifecycle/reset_factors`, payload)

export const resetSpecifiedFactor = (factorId, payload, userId) => gatewayRequestAxios.delete(`${GATEWAY_API_USERS_URL}/${userId}/lifecycle/factors/${factorId}`, payload)
